import { render, staticRenderFns } from "./CompanySizeContent.vue?vue&type=template&id=0acd16b1"
import script from "./CompanySizeContent.vue?vue&type=script&lang=js"
export * from "./CompanySizeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports